import gql from 'graphql-tag';

export default gql`
  mutation createOneVoteMutation($type: String!, $entity: MongoID!, $voteRate: Int!) {
    createOneVoteMutation(type: $type, entity: $entity, voteRate: $voteRate) {
      title
      message
    }
  }
`;
